import React, { PureComponent } from 'react';
import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import './step.css';
import logoPic from 'images/index/logo.png';
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import { Message } from 'element-react';
import { Link } from 'react-router-dom';

export default class ResetPassword extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            images: [],
            phone: ''
        }
    }

    componentWillMount() {
        // 当前页刷新时获取路由参数值
        var search = this.props.location.search;
        var index = search.lastIndexOf("\=");
        var searchVal = search.substring(index + 1, search.length);
        console.log(searchVal);
        this.setState({ phone: searchVal })
    }

    reset(){
        if(this.refs.code.value == ''){
            Message.error("请输入验证码");
            return false;
        }
        let { phone } = this.state;
        let params = {
            phone: phone,
            smsCode: this.refs.code.value
        };
        Http.post(Request.getDebugUrl() + 'blade-portal/registerserver/verifyIdentity', params, obj => {
            if (obj && obj.code == 200) {
                this.props.history.replace("/reset?phone=" + this.state.phone);
            }else {
                Message.error(obj.msg);
                return false;
            }
        });
    
    }

    //获取短信验证码
    getCode(){
        let { phone } = this.state;
        let params = {
            phone: phone
        };
        Http.get(Request.getDebugUrl() + 'blade-portal/registerserver/getSmsCode', params, obj => {
            console.log("sms==",obj);
            if (obj && obj.code == 200) {
                Message.success("发送成功");
            }else {
                Message.error(obj.msg);
                return false;
            }
        });
    }

    render() {
        let { phone } = this.state;
        return (
            <div>
                <GlobalHeader history={this.props.history} />
                <div className="main_step">

                    {/* {内容区域*/}
                    <div className="center">
                        <div className="content">
                            <div className="content_box_step">
                                <div className="content_box_header"><span style={{ color: '#4C4C4C', fontSize: '18px' }}>安全验证</span></div>
                                <div className="content_box_step_title">您的账号存在风险，为保障帐号安全，登录前需验证身份</div>
                                <div className="content_box_security">安全验证</div>
                                <div className="content_box_phone"><input ref="phone" value={phone} readonly="readonly"></input></div>
                                <div style={{ textAlign: 'center' }}>
                                    <input ref="code" placeholder="请输入验证码" className="check_code"></input>
                                    <button className="content_box_send" onClick={this.getCode.bind(this)}>发送验证码</button>
                                </div>
                                <div className="content_box_login" onClick={this.reset.bind(this)}><span>确定</span></div>
                            </div>
                        </div>
                    </div>

                    {/*内容区域} */}

                    <GlobalFooter />


                </div>
            </div>
        )
    }
}